module.exports = __webpack_public_path__ + "img/step-6.d68897df.jpg";